import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginFromSoftwareComponent } from './login.from.software/login.from.software.component';

import { BlankView } from '../views/blank/blank.view';

const LoginFromSoftwareRoutes: Routes = [
    // login view

    {
        path: 'login-from-software', component: BlankView,
        // canActivate: [AuthGuardService],
        children: [
            { path: ':loginToken', component: LoginFromSoftwareComponent },
            { path: '**', component: LoginFromSoftwareComponent }
        ]
    },
];

@NgModule({
    imports: [RouterModule.forChild(LoginFromSoftwareRoutes)],
    exports: [RouterModule]
})
export class LoginFromSoftwareRoutingModule { }
